"use client";
import {
  useComboboxStore
} from "../__chunks/JLHQNPGM.js";
import "../__chunks/CLHN7VYT.js";
import "../__chunks/SZTI5KAP.js";
import "../__chunks/W6MTWV42.js";
import "../__chunks/NGV5ZW5X.js";
import "../__chunks/H5Z3PUKM.js";
import "../__chunks/55ENK5IP.js";
import {
  ComboboxContextProvider
} from "../__chunks/6C2ASARV.js";
import "../__chunks/467XRHWL.js";
import "../__chunks/2LVHRIRC.js";
import "../__chunks/FYYAZUDI.js";
import "../__chunks/NO3UEYQ2.js";
import "../__chunks/SOQQIDO4.js";
import "../__chunks/CTVD4XJH.js";
import "../__chunks/L4OUMOCQ.js";
import "../__chunks/W2TDKEPX.js";
import "../__chunks/AZVQSWGA.js";

// src/combobox/combobox-provider.tsx
import { jsx } from "react/jsx-runtime";
function ComboboxProvider(props = {}) {
  const store = useComboboxStore(props);
  return /* @__PURE__ */ jsx(ComboboxContextProvider, { value: store, children: props.children });
}
export {
  ComboboxProvider
};
